export default "__VITE_ASSET__BpVMvYht__"